import {httpGet,httpPut,httpDelete,httpPost} from '../../../util/request.js';
import appConfig from '../../../config';

export default class Permission{

    static QUERY_MY_PREVILEDGE_MENU_TREE_API_URL = appConfig.gatewayUrl+appConfig.authServicePath+"/auth/my_app_previledge";
    static QUERY_BUTTON_PREVILEDGE_API_URL = appConfig.gatewayUrl+appConfig.authServicePath+"/auth/buttonPriviledge";
    static QUERY_PRIVILEDGE_ORG_API_URL = appConfig.gatewayUrl+appConfig.authServicePath+"/auth/shopPriviledge";
	
	//获取所有有权限的树形结构菜单
	static queryPreviledgeMenuTree(){
		let params={};
		return httpGet(Permission.QUERY_MY_PREVILEDGE_MENU_TREE_API_URL,params);
    }

    //获取菜单下按钮以及按钮权限情况
    static queryButtonPriviledge(menuId,menuCode){
        let params={menuId:menuId,menuCode:menuCode};
        return httpGet(Permission.QUERY_BUTTON_PREVILEDGE_API_URL,params);
    }
    
    //查询组织权限情况
	static queryShopPriviledge(params){
		return httpGet(Permission.QUERY_PRIVILEDGE_ORG_API_URL,params);
    }
    
    static handleResponse(response, scope, successFunc,errorFunc){
        let data = response.data;
        if(data.code == 200){
            if(successFunc && typeof successFunc == 'function'){
                successFunc(data.data);
            }
        }else{
            let text = data.errMsg
            scope.$dialog.error({
                text: text,
                title: "错误"
            });
            if(errorFunc && typeof errorFunc == 'function'){
                errorFunc(data);
            }
        }
    }

}